
import React from 'react';
import { Modal, Spinner } from 'react-bootstrap'
import './index.css'

const Loading = (props) => {
    return (
      <Modal 
        dialogClassName='modal-loading'
        show={props.modalShow}>
          <Spinner animation="border" variant="light"  role="status"/>
      </Modal>
    )
}

export default Loading
